// The passive line under a login button.
//
// This is notice, not consent. Logging in is a deliberate act by someone who
// already has an account, so what is owed here is that they can find the terms
// and the privacy notice and see whose they are. The boxes that actually
// record a consent live in ConsentChecklist, on the form that creates the
// account.

import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography } from '@mui/material';
//
import { DOC_LABELS, LEGAL_PATHS, operatorName } from './legalCopy';

// ----------------------------------------------------------------------

ConsentNotice.propTypes = {
  org: PropTypes.object,
  action: PropTypes.string,
  colour: PropTypes.string,
  sx: PropTypes.object,
};

export default function ConsentNotice({ org, action = 'continuing', colour, sx }) {
  const name = operatorName(org);
  const linkSx = {
    color: colour || 'text.secondary',
    textDecorationColor: 'currentColor',
    fontWeight: 600,
  };

  return (
    <Typography
      variant="caption"
      align="center"
      sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.6, ...sx }}
    >
      By {action} you agree to {name}&apos;s{' '}
      <Link component={RouterLink} to={LEGAL_PATHS.terms} target="_blank" rel="noopener" sx={linkSx}>
        {DOC_LABELS.terms}
      </Link>{' '}
      and{' '}
      <Link
        component={RouterLink}
        to={LEGAL_PATHS.privacy}
        target="_blank"
        rel="noopener"
        sx={linkSx}
      >
        {DOC_LABELS.privacy}
      </Link>
      .
    </Typography>
  );
}
